module.exports = __webpack_public_path__ + "img/banner.49a9e665.png";